import {inject, Injectable} from '@angular/core';
import {ChatStore} from '../../modules/chat/chat-store/chat-store';
import {KnowledgebaseStore} from '../../modules/knowledge-base/kb-store/knowledgebase-store';
import {CalendarStore} from '../../modules/calendar/stores/calendar-store';
import {NewsStore} from '../../modules/news/store/news-store';
import {RightsStore} from '../../modules/settings/dialog-right-settings/rights-page/store/rights-store';
import {DynamicTranslationsStore} from '../stores/dynamic-translations-store';
import {CustomerService} from './customer.service';
import {MaintenanceService} from './maintenance.service';
import {DocumentService} from './document.service';
import {FirebaseService} from './firebase.service';
import {ApiService} from './api.service';
import {customerUserGuard} from '../guards/customer-user.guard';

@Injectable({
  providedIn: 'root'
})
export class AppStoreResetService {
  private readonly chatStore: InstanceType<typeof ChatStore> = inject(ChatStore);
  private readonly knowledgebaseStore: InstanceType<typeof KnowledgebaseStore> = inject(KnowledgebaseStore);
  private readonly calendarStore: InstanceType<typeof CalendarStore> = inject(CalendarStore);
  private readonly newsStore: InstanceType<typeof NewsStore> = inject(NewsStore);
  private readonly rightsStore: InstanceType<typeof RightsStore> = inject(RightsStore);
  private readonly dynamicTranslationsStore: InstanceType<typeof DynamicTranslationsStore> = inject(DynamicTranslationsStore);
  private readonly customerService: CustomerService = inject(CustomerService);
  private readonly maintenanceService: MaintenanceService = inject(MaintenanceService);
  private readonly documentService: DocumentService = inject(DocumentService);
  private readonly firebaseService: FirebaseService = inject(FirebaseService);
  private readonly apiService: ApiService = inject(ApiService);
  private readonly customerUserGuard: customerUserGuard = inject(customerUserGuard);

  public resetAllStores(): void {
    this.chatStore.resetStore();
    this.knowledgebaseStore.resetStore();
    this.calendarStore.resetStore();
    this.newsStore.resetStore();
    this.rightsStore.resetStore();
    this.dynamicTranslationsStore.resetStore();
    this.customerService.resetAuthenticatedCustomerData();
    this.maintenanceService.resetState();
    this.documentService.resetState();
    this.firebaseService.resetState();
    this.customerUserGuard.resetGdprState();
  }
}
